var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 105,
    viewBox: "0 0 156 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1910_126985)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.912,
    cy: 49.2188,
    rx: 46.2401,
    ry: 46.5938,
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4512 21.6433C37.565 21.6433 34.2085 23.9258 32.5983 27.237C32.8784 22.4419 36.7486 18.6602 41.4512 18.6602H129.936C134.645 18.6602 138.509 22.4418 138.789 27.2371C137.18 23.9249 133.826 21.6433 129.936 21.6433H41.4512ZM32.582 81.7163V39.5717H138.805V81.7163C138.805 86.7724 134.819 90.8506 129.936 90.8506H41.4512C36.5678 90.8506 32.582 86.7724 32.582 81.7163Z",
    fill: "#D9D8DF",
    stroke: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4512 18.6602H129.936C134.831 18.6602 138.805 22.6962 138.805 27.6896V34.5886H32.582V27.6896C32.582 22.6965 36.5627 18.6602 41.4512 18.6602Z",
    fill: "#D9D8DF",
    stroke: "#D9D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M123.737 51.7676H101.749M123.737 63.2191H101.749M91.3727 51.7676H46.9023M91.3727 63.2191H46.9023M91.3727 73.426H46.9023",
    stroke: "#FDFDFD",
    strokeWidth: 5.20389,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.42 82.6367C111.967 82.6367 114.843 79.7388 114.843 76.164C114.843 72.5893 111.967 69.6914 108.42 69.6914C104.872 69.6914 101.996 72.5893 101.996 76.164C101.996 79.7388 104.872 82.6367 108.42 82.6367Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.068 82.6367C120.616 82.6367 123.492 79.7388 123.492 76.164C123.492 72.5893 120.616 69.6914 117.068 69.6914C113.52 69.6914 110.645 72.5893 110.645 76.164C110.645 79.7388 113.52 82.6367 117.068 82.6367Z",
    fill: "#006546"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.719 80.9055C113.973 79.7268 114.757 78.0469 114.757 76.1823C114.757 74.3176 113.973 72.6375 112.719 71.459C111.464 72.6375 110.68 74.3176 110.68 76.1823C110.68 78.0469 111.464 79.7268 112.719 80.9055Z",
    fill: "#006546"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1910_126985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.317893b45f9f2822c59e5c512371cc35.svg";
export { ForwardRef as ReactComponent };